module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "crt"
  }, [_vm._v("Copyright © 2013 by Yan Lianke"), _c('br'), _vm._v("English translation copyright © 2016 by Carlos Rojas")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover photograph © Chen Yu, Untitled, 2011"), _c('br'), _vm._v("Series No. 1, 2011/Schoeni Art Gallery,"), _c('br'), _c('a', {
    attrs: {
      "href": "http://HongKong/schoeniartgallery.com",
      "target": "_blank"
    }
  }, [_vm._v("Hong Kong/schoeniartgallery.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove/Atlantic, Inc., 154 West 14th Street, New York, NY 10011 or "), _c('a', {
    attrs: {
      "href": "mailto:permissions@groveatlantic.com"
    }
  }, [_vm._v("permissions@groveatlantic.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First published as "), _c('em', [_vm._v("Zhalie zhi")]), _vm._v(" by Shanghai 99 in 2013")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_vm._v("Printed in the United States of America"), _c('br'), _vm._v("Published simultaneously in Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN: 978-0-8021-2582-8"), _c('br'), _vm._v("eISBN: 978-0-8021-9001-7")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First Grove Atlantic hardcover edition: October 2016")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The Library of Congress has cataloged the Grove Atlantic edition as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "copy"
  }, [_c('p', {
    staticClass: "crt1"
  }, [_vm._v("Yan, Lianke, 1958- author. | Rojas, Carlos, 1970- translator.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("The explosion chronicles : a novel / Yan Lianke ; translated by Carlos Rojas.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Other titles: Zhalie zhi. English")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Description: New York : Grove Press, 2016. | Orginally published in Chinese as Zha lie zhi (Taibei Shi : Mai tian chu ban, 2013).")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Identifiers: LCCN 2016023950 (print) | LCCN 2016032248 (ebook) | ISBN 9780802125828 (hardback) | ISBN 9780802190017 (eBook)")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Subjects: LCSH: Upper class families—Fiction. | Cities and towns—Growth—Fiction. | Competition—Fiction. | Power (Social sciences)—Fiction. | China—Fiction. | BISAC: FICTION / Literary.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Classification: LCC PL2925.L54 Z413 2016 (print) | LCC PL2925.L54 (ebook) | DDC 895.13/52—dc23")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("an imprint of Grove Atlantic"), _c('br'), _vm._v("154 West 14th Street"), _c('br'), _vm._v("New York, NY 10011")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    attrs: {
      "href": "http://groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("groveatlantic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("17 18 19 20 10 9 8 7 6 5 4 3 2 1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d230dbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/cop.vue
// module id = 69
// module chunks = 0